import { useEffect, useState } from 'react';
import { APIS } from '../../constants/apis';
import { fetchAPI } from '../../utils/fetchAPI';
import mockUser from '../../dev/mocks/mockUser.json';

export const useUserData = ({ jwt, userId }) => {
  const [userData, setUserData] = useState();
  const [mood, setMood] = useState();
  const [isUserLoading, setIsUserLoading] = useState(true);

  if (process.env.REACT_APP_LOCAL_DEV === 'true') {
    userId = mockUser.userId;
    jwt = 'secure_token';
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const getUser = async () => {
          const userData = await fetchAPI({
            url: `${APIS.getUser}${userId}`,
            method: 'GET',
            header: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          setUserData(userData);
        };

        const getMood = async () => {
          const mood = await fetchAPI({
            url: `${APIS.getMood}${userId}`,
            method: 'GET',
            header: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          setMood(mood);
        };

        await Promise.all([getUser(), getMood()]);

        setIsUserLoading(false);
      } catch (err) {
        throw new Error(err.message);
      }
    };

    if (userId && jwt) {
      getData();
    }
  }, [jwt, userId]);

  return { userData, mood, isUserLoading };
};
